import React from 'react';
import { galleryImages } from '../mockData';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Phone } from 'lucide-react';

export const GalleryPage = () => {
  const navigate = useNavigate();

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-gray-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Our Projects</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            See the quality of our workmanship across Greater Sydney. From residential homes to commercial properties, we deliver excellence.
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="section-padding bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-12">
            {galleryImages.map((image, index) => {
              const imageKey = `gallery-page-${index}-${image.slice(-15)}`;
              return (
                <div
                  key={imageKey}
                  className="group relative overflow-hidden rounded-xl shadow-lg cursor-pointer aspect-[4/3]"
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  <img
                    src={image}
                    alt={`Dezire Metal Roofing Project ${index + 1}`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                      <h3 className="text-xl font-bold mb-1">Project {index + 1}</h3>
                      <p className="text-sm text-gray-300">Metal Roofing Installation - Greater Sydney</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Stats Section */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <div className="text-4xl font-bold text-primary mb-2">2000+</div>
              <p className="text-gray-600 font-semibold">Projects Completed</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <div className="text-4xl font-bold text-primary mb-2">100%</div>
              <p className="text-gray-600 font-semibold">Client Satisfaction</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <div className="text-4xl font-bold text-primary mb-2">40+</div>
              <p className="text-gray-600 font-semibold">Years Experience</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <div className="text-4xl font-bold text-primary mb-2">24/7</div>
              <p className="text-gray-600 font-semibold">Emergency Service</p>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center bg-white p-12 rounded-xl shadow-lg">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Want Your Property to Look This Good?
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Let our expert team transform your roof with premium metal roofing. Get a free inspection and quote today.
            </p>
            <Button
              size="lg"
              onClick={() => navigate('/contact')}
              className="bg-primary hover:bg-accent text-white text-lg px-8 py-6"
            >
              <Phone className="w-5 h-5 mr-2" />
              Book Free Inspection
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};
